module.exports = __webpack_public_path__ + "img/googleplay-qr.87c4a553.svg";